module.exports = __webpack_public_path__ + "2f14e92c3c7b0ef692474ecd352ab05a.pdf";